var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"head-title"},[_vm._v(_vm._s(_vm.serveName))]),_c('div',{staticClass:"head-lab"},[_c('span',[_vm._v("服务方 : ")]),_vm._v(_vm._s(_vm.laboratoryName))])])}
var staticRenderFns = []

export { render, staticRenderFns }